module.exports = __webpack_public_path__ + "static/media/ico_status_fail.a01f0e07.svg";